/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { withHandlers } from 'recompose'
import { DropdownItem } from 'reactstrap'

interface IProps {
  children?: any,
  active?: boolean,
  value?: any,
  onClick?: (val: any) => any,
  onChange?: (val: any) => any,
}

const SelectItem: React.SFC<IProps> = ({ children, ...restProps }) => {
  return (
    <DropdownItem {...restProps} >{children}</DropdownItem>
  )
}

export default withHandlers<any, any>({
  onClick: ({ onChange, value }) => () => {
    onChange({ value })
  },
  onKeyDown: ({ onChange, value }) => event => {
    if (event.keyCode !== 13) {
      return
    }
    onChange({ value })
  },
})(SelectItem)
